module.exports = __webpack_public_path__ + "static/media/backScotland.178fb867.png";